export function BasketContentHeader(props) {
    const { cartItemsCount, favoriteItemsCount, activeTab } = props;
    const countItems = (count) => count > 0 ? `(${count})` : '';

    const isActiveTab = (index) => {
        return activeTab === index ? "active" : "";
    };

    const onTabClick = (index) => {
        props.changeCartType(index);
    };

    return (
        <div className="col-auto" id="basket-title">
            <div className="row mb-8">
                <div className="col">
                    <div className={"underline-btn show-btn pb-15 sm-me-0 " + isActiveTab(0)} data-show="#bag-box" onClick={() => onTabClick(0)}>
                        Shopping bag {countItems(cartItemsCount)}
                    </div>
                    <div className={"underline-btn show-btn pb-15 sm-me-0 " + isActiveTab(1)} data-show="#save-for-later-box" onClick={() => onTabClick(1)}>
                        Save for later {countItems(favoriteItemsCount)}
                    </div>
                </div>
                <div className="col-auto">
                    <span className="curtains-icon curtains-icon-close size-24 pointer" onClick={e => props.toggleBascket(e, false)}></span>
                </div>
            </div>
        </div>
    );
}
